import { render, staticRenderFns } from "./SiryoAndLink.vue?vue&type=template&id=e19a8166&scoped=true&"
import script from "./SiryoAndLink.vue?vue&type=script&lang=js&"
export * from "./SiryoAndLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19a8166",
  null
  
)

export default component.exports